import { TAssistantTool } from "../../../services/api/instances/assistantsApi/types";
import { TSkills } from "../../../services/api/instances/skillsApi/types";
import { getInstructionWithoutHiddenPartWithTrim } from "./getInstructionWithoutHiddenPart";

export const rebuildSecurityBlocks = (
  globalInstruction: string,
  assistantTools: TAssistantTool[] | null,
  skills: TSkills | null,
  cleanInstruction?: string,
): string => {
  const instruction = cleanInstruction
    ? cleanInstruction
    : getInstructionWithoutHiddenPartWithTrim(globalInstruction);
  const blocks: string[] = [];

  if (assistantTools) {
    assistantTools.forEach((tool) => {
      const newWhen = `<security>${tool.when}\nassistant_ref: ${tool.ref}</security>`;
      blocks.push(newWhen);
    });
  }

  if (skills) {
    skills.forEach((skill) => {
      if (skill.name && skill.name.trim() !== "") {
        blocks.push(
          `<security>Вызови функцию plugin_call_skill с ${skill?.name} если нужно получить описание роли смотри в ${skill?.description}</security>`,
        );
      }
    });
  }

  const parts = [instruction, blocks.join("\n")].filter(
    (part) => part.trim() !== "",
  );

  return parts.length > 0 ? parts.join("\n\n") : "";
};
